import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // window.scrollTo({
    //   top: 0,
    //   left: 0,
    //   behavior: "auto",
    // });

      // Intentar inmediatamente
      window.scrollTo(0, 0);
      
      // Y luego nuevamente después de un delay por si acaso
      const timer1 = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      
      const timer2 = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 500);

      return () => {
        clearTimeout(timer1);
        clearTimeout(timer2);
      };
  }, [pathname]);

  return null;
};

export default ScrollToTop;